import { CheckCircleIcon, XCircleIcon } from '@phosphor-icons/react';

import { ActionMenu } from '@/components/common/action-menu';
import type { Role } from '@/types';

import { canReviewRequest } from '../permissions';
import type { InstallationRow } from '../types';

/** Row ellipsis for the installations queue. Approve/Reject are available **only when Open**
 *  (ADR-0018); the other statuses are terminal/non-actionable, so the menu is absent. */
export function InstallationActionsMenu({
  row,
  viewerRole,
  onApprove,
  onReject,
}: {
  row: InstallationRow;
  /** The signed-in admin's role, from `useAuth().user` on the queue page. Required, not
   *  optional: a default would re-open this gate the next time a queue is built. */
  viewerRole: Role | null;
  onApprove: (row: InstallationRow) => void;
  onReject: (row: InstallationRow) => void;
}) {
  if (row.status !== 'open') return null;
  // Row status decides whether the request is actionable at all; the viewer's role decides
  // whether *this* admin may act on it. Both must hold. No ellipsis rather than disabled items:
  // every other branch in this file returns `null`, and an Operational Associate's view of the
  // queue is read-only, so an always-dead trigger would be chrome with nothing behind it.
  if (!canReviewRequest(viewerRole)) return null;

  return (
    <ActionMenu
      triggerLabel={`Actions for ${row.orderNumber}`}
      groups={[
        {
          items: [
            {
              key: 'approve',
              label: 'Approve',
              icon: <CheckCircleIcon size={16} />,
              onClick: () => onApprove(row),
            },
            {
              key: 'reject',
              label: 'Reject',
              icon: <XCircleIcon size={16} />,
              danger: true,
              onClick: () => onReject(row),
            },
          ],
        },
      ]}
    />
  );
}
